import Services from './index';
import { NOTIFICATION_URL } from 'consts/api';

class NotificationService {
  getNotification({ limit, offset, status }) {
    return Services.post(NOTIFICATION_URL, {
      action: 'get',
      limit,
      offset,
      status,
    });
  }

  countNotification() {
    return Services.post(NOTIFICATION_URL, {
      action: 'countUnread',
    });
  }

  updateNotification({ notifications, status }) {
    return Services.post(NOTIFICATION_URL, {
      action: 'update',
      notifications,
      status,
    });
  }

  markAllAsRead() {
    return Services.post(NOTIFICATION_URL, {
      action: 'markAllAsRead',
    });
  }
}

export default new NotificationService();
